import { inject, Injectable } from '@angular/core';
import {
	Router,
	CanActivateFn,
	CanActivateChildFn,
	CanMatchFn,
} from '@angular/router';
import { Observable } from 'rxjs';
import { SessionStore } from '../store/session.store';

@Injectable({
	providedIn: 'root',
})
export class AnonymousGuard {
	private _store = inject(SessionStore);
	private _router = inject(Router);

	canActivate: CanActivateFn = () => this.check();
	canActivateChild: CanActivateChildFn = () => this.check();
	canMatch: CanMatchFn = () => this.check();

	private check(): Observable<boolean> {
		const token = this._store.token();
		if (!!token) {
			this._router.navigate(['/network/dashboard']);
			return new Observable<boolean>((observer) => {
				observer.next(false);
				observer.complete();
			});
		}
		return new Observable<boolean>((observer) => {
			observer.next(true);
			observer.complete();
		});
	}
}
